import { createContext, useState, useCallback, useEffect, useRef, useContext } from "react";
import { AuthContext } from "./AuthContext";

export const MeetingContext = createContext();

export const MeetingProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const prevUserRef = useRef(user);
  const [localStream, setLocalStream] = useState(null);
  const [myPeer, setMyPeer] = useState(null);
  const [participants, setParticipants] = useState([]);
  const [isMeetingActive, setIsMeetingActive] = useState(false);
  const [meetingId, setMeetingId] = useState(null);
  const [accessCode, setAccessCode] = useState(null);
  const [constraints, setConstraints] = useState(null);
  const [isIntentionalLeave, setIsIntentionalLeave] = useState(false);
  const [isReconnecting, setIsReconnecting] = useState(false);

  // Nettoyage automatique de la reunion lors de la deconnexion
  useEffect(() => {
    if (prevUserRef.current && !user) {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop());
      }
      setIsMeetingActive(false);
      setMeetingId(null);
      setAccessCode(null);
      setConstraints(null);
      setLocalStream(null);
      setMyPeer(null);
      setParticipants([]);
      setIsIntentionalLeave(false);
      setIsReconnecting(false);
    }
    prevUserRef.current = user;
  }, [user]);

  const joinMeetingSession = useCallback((mId, aCode, cons) => {
    setMeetingId(mId);
    setAccessCode(aCode);
    setConstraints(cons);
    setIsMeetingActive(true);
    setIsIntentionalLeave(false);
  }, []);

  const endMeetingSession = useCallback((intentional = true) => {
    setIsIntentionalLeave(intentional);
    setIsMeetingActive(false);
    setMeetingId(null);
    setAccessCode(null);
    setConstraints(null);
    setLocalStream(null);
    setMyPeer(null);
    setParticipants([]);
    setIsReconnecting(false);
  }, []);

  const startReconnection = useCallback(() => {
    setIsReconnecting(true);
  }, []);

  const endReconnection = useCallback((success) => {
    setIsReconnecting(false);
    if (!success) {
      setIsIntentionalLeave(true);
      setIsMeetingActive(false);
      setMeetingId(null);
      setAccessCode(null);
      setConstraints(null);
      setLocalStream(null);
      setMyPeer(null);
      setParticipants([]);
    }
  }, []);

  return (
    <MeetingContext.Provider
      value={{
        localStream,
        setLocalStream,
        myPeer,
        setMyPeer,
        participants,
        setParticipants,
        isMeetingActive,
        meetingId,
        setMeetingId,
        accessCode,
        setAccessCode,
        constraints,
        setConstraints,
        joinMeetingSession,
        endMeetingSession,
        isIntentionalLeave,
        setIsIntentionalLeave,
        isReconnecting,
        startReconnection,
        endReconnection,
      }}
    >
      {children}
    </MeetingContext.Provider>
  );
};
